import React from "react";
import { ErrorAlert } from "components/errorAlert/ErrorAlert";
import useErrorStore from "stores/useErrorStore";
import { getTranslation } from "utils/translation";

export const Error401 = () => {
  const { setErrorCode } = useErrorStore();
  return (
    <ErrorAlert
      title={getTranslation("resource", "UNAUTHORIZED")}
      errorCode={401}
      buttonTitle={getTranslation("resource", "TRY_AGAIN_LOGIN")}
      onClick={() => {
        setErrorCode(null);
        window.location.href = "/#/login";
      }}
    >
      <p>{getTranslation("message", "ERROR.ACCOUNT_AGAIN")}</p>
    </ErrorAlert>
  );
};
